<template>
  <v-container>
    <v-btn text dark color="orange" @click="$router.push({name: 'Dashboard', params: {tag: dashboardTag}})"> Back</v-btn>
    <v-card class="text-center ma-5 pa-5" v-if="initialDecision">
      <div class="subtitle-1">
        What would you like to do?
      </div>
      <v-btn class="ma-3" v-if="isAuth" color="orange" outlined @click="restoreLastReview">Start/Continue Review</v-btn>
      <br />
    </v-card>

    <div v-if="!initialDecision">
      <div v-if="deckContent" class="title text-center">
        <span class="orange--text">{{deckContent.length}}</span> |
        <span class="purple--text">{{reviewCards.length}}</span> |
        <span class="blue--text">{{knowCards.length}}</span>
      </div>
      <v-row v-if="!complete">
        <v-flex>

        </v-flex>
        <v-flex>

        </v-flex>
        <v-flex>

        </v-flex>

      </v-row>

      <cardQuestionAnswer v-if="deckContent" :card="cardSource[0]" @answerState="setAnswerState" @hotkey="hotkeyactions"/>

        <div class="text-center mt-5" v-if="showKnowledgeButtons">
            <v-btn outlined color="orange" class="mx-2" @click="likeNewCard">Again</v-btn>
            <v-btn outlined color="purple" class="mx-2" @click="reviewCard">Review</v-btn>
            <v-btn outlined color="blue" class="mx-2" @click="knowCard">Know</v-btn>
            <p class="py-5 my-3" v-if="deckContent">
              <a :href="'mailto:content@omentum.app?body=Please%20include%20a%20description%20and%20screenshot%20if%20possible%20below.%20Thank%20you!&subject=Content%20problem%20with%20card%20' + cardSource[0].id">Need to report a problem with this card?</a>
            </p>
        </div>



    </div>


    <p class="mt-5 pt-5 ml-5" v-if="!isAuth">
      Want to save your practice?
      <router-link :to="{name: 'SignUp'}">Sign up</router-link> or
      <router-link :to="{name: 'Login'}">Login</router-link>
    </p>


    <v-progress-circular v-if="loading" class="center-element" large indeterminate :size="90" :width="15" color="orange"></v-progress-circular>


  </v-container>
</template>

<script>
import db from '@/fb'
import Obj from '@/objects'
import cardQuestionAnswer from '@/components/cardQuestionAnswer.vue'
import firebase from 'firebase'
import uuid from 'uuid/v4'
import _ from 'underscore'
import moment from 'moment'

export default {
  name: 'Review',
  components: {
    cardQuestionAnswer
  },
  data() {
    return {
      subject: null,
      showKnowledgeButtons: false,
      initialDecision: true,
      deckId: null,
      deckContent: null,
      deckIndex: 0,
      knowCards: [],
      reviewCards: [],
      complete: false,
      loading: false,
      sessionId: uuid(),
      dashboardTag: null,

    }
  },
  computed: {
    isAuth() {
      if (firebase.auth().currentUser) {
        return true
      }
      else {
        return false
      }
    },
    cardSource() {
      if (this.deckContent.length > 0) {
        return this.deckContent
      }
      else if (this.reviewCards.length > 0) {
        return this.reviewCards

      }
      else {
        this.complete = true
        this.initialDecision = true
        return [{question: 'All done', answer: 'Yay!'}]
      }
    }


  },
  mounted() {
    this.subject = this.$route.params.subject
    console.log(this.subject)

    if (this.$route.params.tag) {
      this.dashboardTag = this.$route.params.tag
    }

    Obj.indicateUserReviewState() //set for recalculating deck progress post review

  },
  methods: {
    hotkeyactions(key) {
      switch (key) {
        case 1:
          this.likeNewCard()
          break
        case 2:
          this.reviewCard()
          break
        case 3:
          this.knowCard()
          break
        default:
          break
      }
    },

    setAnswerState(answerState) {
      this.showKnowledgeButtons = answerState
    },
    likeNewCard(){
      this.logSignedOutAnswers(0)
      if (firebase.auth().currentUser) {
        this.recordKnowledge(0)

      }
       //level 0 knowledge
      if (this.deckContent.length > 10) {
        this.deckContent.splice(10, 0, this.cardSource.shift())
      }
      else {
        this.deckContent.push(this.cardSource.shift())
      }
    },
    reviewCard() {
      this.logSignedOutAnswers(1)
      if (firebase.auth().currentUser) {
        this.recordKnowledge(1) //level 1 knowledge

      }
      this.reviewCards.push(this.cardSource.shift())
    },
    knowCard() {
      this.logSignedOutAnswers(2)
      if (firebase.auth().currentUser) {
        this.recordKnowledge(2)
      }
       //level 2 knowledge
      this.knowCards.push(this.cardSource.shift())
    },
    recordKnowledge(knowledgeLevel) {
      let time = new Date()

      let data = {
        cardId: this.cardSource[0].id,
        deckId: this.cardSource[0].deck,
        uid: firebase.auth().currentUser ? firebase.auth().currentUser.uid : null,
        timestamp: time.toString(),
        knowledgeLevel
      }
      if (data.uid) {
        let recordHistoryAndKnowledge = firebase.functions().httpsCallable('recordHistoryAndKnowledge')
        recordHistoryAndKnowledge(data).then(response => console.log(response))
      }
    },
    logSignedOutAnswers(knowledgeLevel){
      let time = new Date()

      let data = {
        cardId: this.cardSource[0].id,
        deckId: this.cardSource[0].deck,
        uid: firebase.auth().currentUser ? firebase.auth().currentUser.uid : null,
        sessionId: this.sessionId,
        timestamp: time.toString(), //server time replaces this
        result: knowledgeLevel
      }
      let logAction = firebase.functions().httpsCallable('logAction')
      logAction(data)
      .then(response => {
        console.log(response)
      })
    },

    restoreLastReview() {
      this.loading = true
      this.getCards().then(result => {
        this.deckContent = []
        this.knowCards = []
        this.reviewCards = []

        result.forEach(card => {

          if (card.knowledge == null) {
            this.deckContent.push(card)
          }
          else {
            let expired = moment(card.knowledge.timestamp).add(4, 'days') < moment()
            if (card.knowledge.knowledgeLevel == 2 && !expired) {
              this.knowCards.push(card)
            }
            else if (card.knowledge.knowledgeLevel == 2 && expired) {
              this.reviewCards.push(card)
            }
            else if (card.knowledge.knowledgeLevel == 1) {
              this.reviewCards.push(card)
            }
            else {
              this.deckContent.push(card)
            }
          }



        })
        this.loading = false
        this.initialDecision = false
      })
    },

    getCards() {
      //'retrieveSubjectKnowledge'
      let data = {
        subject: this.subject,
        uid: firebase.auth().currentUser.uid,
      }
      let retrieveSubjectKnowledge = firebase.functions().httpsCallable('retrieveSubjectKnowledge')
      return retrieveSubjectKnowledge(data)
      .then(response => {
        return response.data
      })
    },

  }
}
</script>
<style>

</style>
